<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_28_624)">
      <path d="M21.855 10.438h-8.148c-1.189 0-1.792.396-1.792.396l-6.291 4.728a.679.679 0 0 0-.106.121 1.125 1.125 0 0 0-.386.84c0 .628.509 1.137 1.137 1.137.259 0 .484-.105.675-.252v.026l.367-.258c.845-.545 4.27-2.762 4.562-2.932.334-.193.807-.167 1.167.333.416.834-.639 1.444-.639 1.444L8.726 18.42c-.718.469-1.352.562-1.668.578l-5.184.022c-.084 0-.162.005-.242.008h-.397c-.012 0-.022-.007-.033-.007-.392 0-.72.213-.922.518a1.093 1.093 0 0 0-.204.608c0 .62.504 1.124 1.126 1.124h8.485a4.436 4.436 0 0 0 2.285-.704l5.585-3.68c.017-.011.533-.353 1.475-.359a93.349 93.349 0 0 1 2.11.007h.048c.045 0 .122-.003.211-.015h.453a1.123 1.123 0 0 0 1.124-1.124v-3.833a1.126 1.126 0 0 0-1.124-1.124h.001ZM.46 5.754s.011.065.041.18v.004h.001c.19.744 1.15 3.672 4.912 6.257l.002.01.369.245.213-.14.002-.008c3.953-2.651 4.904-5.705 5.075-6.4l.002-.003c.021-.093.031-.146.031-.146l-.011-.003c.019-.174.04-.473-.021-.735 0-.008-.008-.006-.01-.014a2.656 2.656 0 0 0-2.619-2.23 2.653 2.653 0 0 0-2.644 2.486h-.035A2.656 2.656 0 0 0 3.123 2.77 2.654 2.654 0 0 0 .487 5.16c-.012.007-.021.024-.027.057-.029.167-.01.38.012.534l-.012.004Z" fill="#F87900" />
    </g>
    <defs>
      <clipPath id="clip0_28_624">
        <path fill="#fff" transform="translate(0 .5)" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
}
</script>
